import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Definition } from '../../../../core/store/definitions/definition.interface';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'admin-i18n-selector',
  templateUrl: './i18n-selector.html',
  styleUrls: ['./i18n-selector.scss'],
})
export class I18nSelector implements OnInit {
  private JSON = '1 language in JSON';
  private CSV = 'All in excel copy/paste format';

  types = [this.JSON, this.CSV];
  languageOptions: Definition[];
  type = this.JSON; // default json type
  selectedLanguage;

  @Input() languages: Definition[];
  @Input() usedLanguage: string;
  @Input() loading: boolean;
  @Input() saving: boolean;

  @Output() editLanguage = new EventEmitter<string>();
  @Output() editAllCsv = new EventEmitter<string>();
  @Output() testLanguage = new EventEmitter<string>();
  @Output() resetLanguages = new EventEmitter<string>();
  @Output() jsonSelected = new EventEmitter<boolean>();
  @Output() selectedJsonLanguage = new EventEmitter<string>();

  i18nSelectorForm: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.i18nSelectorForm = this.formBuilder.group({
      language: [this.usedLanguage, [Validators.required]],
      type: [this.type],
    });
    this.selectedLanguage = this.usedLanguage;
    !this.saving && this.editLanguage.emit(this.selectedLanguage);
    this.i18nSelectorForm.get('language').valueChanges.subscribe((newValue) => {this.onSelectedLanguageChanged(newValue)});
    this.i18nSelectorForm.get('type').valueChanges.subscribe((newValue) => {this.typeChanged()});
  }
  isCsv() {
    return this.i18nSelectorForm.get('type').value === this.CSV;
  }
  isJson() {
    return this.i18nSelectorForm.get('type').value === this.JSON;
  }
  preventRouting(event) {
    event.stopPropagation();
  }

  typeChanged() {
    this.jsonSelected.emit(this.isJson());
  }

  onSelectedLanguageChanged(language: string) {
    this.selectedLanguage = language;
    this.selectedJsonLanguage.emit(language);
    !this.saving && this.editLanguage.emit(this.selectedLanguage);
  }
}
